import { SvgIcon, SvgIconOwnProps } from "@mui/material";
import {
  TaskState,
  TaskType,
  isTaskTypeConcern,
} from "../features/data/patientApiSlice";

import ConcernIcon from "../../assets/task_concern.svg?react";
import FollowupIcon from "../../assets/task_followup.svg?react";
import NewPatientIcon from "../../assets/task_new_patient.svg?react";
import RequestToChatIcon from "../../assets/task_request_to_chat.svg?react";

export const TaskTypeIcon = (
  props: {
    type: TaskType;
    state: TaskState;
  } & SvgIconOwnProps
) => {
  const { type, state, ...rest } = props;
  const isConcern = isTaskTypeConcern(type);
  const color =
    state === TaskState.todo ? (isConcern ? "error" : "primary") : "action";
  switch (type) {
    case TaskType.request_to_chat:
    case TaskType.urgent_request_to_chat:
    case TaskType.pending_hcw_message:
      return (
        <SvgIcon
          component={RequestToChatIcon}
          inheritViewBox
          color={color}
          {...rest}
        />
      );
    case TaskType.followup:
      return (
        <SvgIcon
          component={FollowupIcon}
          inheritViewBox
          color={color}
          {...rest}
        />
      );
    case TaskType.terms_accepted:
      return (
        <SvgIcon
          component={NewPatientIcon}
          inheritViewBox
          color={color}
          {...rest}
        />
      );
    default:
      return (
        <SvgIcon
          component={ConcernIcon}
          inheritViewBox
          color={color}
          {...rest}
        />
      );
  }
};
